import Button from 'shared/components/andtComponents/Button.tsx';
import InfoBanner from 'shared/components/InfoBanner';
import { OrganizationLearnMoreLinks } from 'app/contexts/Brand/configurations/external-links.configuration';

import styles from './CostCentersBanner.module.scss';

const CostCentersBanner = () => {
  const handleInfoLinkClicked = () => {
    window.open(OrganizationLearnMoreLinks.CostCenters, '_blank');
  };

  const bannerText = (
    <div className={styles.bannerText}>
      <p>
        Create your Cost Centers organization here. For ease of use and data completeness, we recommend assigning sub
        accounts to the
      </p>
      <span className={styles.boldText}>lowest level</span>. This will allow future &quot;group by&quot; operations to
      include all the data in the accounts.
      <Button
        className={{ button: styles.learnMoreButton }}
        isTextButton
        onClick={handleInfoLinkClicked}
        text="Learn more"
      />
    </div>
  );

  return <InfoBanner text={bannerText} automationId="close-cost-centers-banner" />;
};

export default CostCentersBanner;
